import basicPlan from "./basicPlan.component";
import basicPlanUrls from "./basicPlan.urls";
import BasicPlanTransforms from "./basicPlan.transforms";

const basicPlanModule = angular
  .module("app.components.basicPlan", [])
  .component("basicPlanPage", basicPlan)
  .service("BasicPlanTransforms", BasicPlanTransforms)
  .config(basicPlanUrls);

export default basicPlanModule;



// WEBPACK FOOTER //
// ./src/pages/basicPlan/basicPlan.module.js